module.exports = __webpack_public_path__ + "img/hasreturndispen.654daee4.svg";